var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckDoubleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7611 9.0563L8.6083 9.9035L13.6879 4.8239L14.5363 5.6723L8.6083 11.6003L4.7899 7.7819L5.6383 6.9335L6.9133 8.2085L7.7611 9.0557V9.0563ZM7.7623 7.3595L10.7335 4.3877L11.5795 5.2337L8.6083 8.2055L7.7623 7.3595ZM6.0661 10.7525L5.2183 11.6003L1.3999 7.7819L2.2483 6.9335L3.0961 7.7813L3.0955 7.7819L6.0661 10.7525Z",
    fill: "#375DFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDoubleFill);
export default __webpack_public_path__ + "static/media/check-double-fill.158a4fe82c5ab92f9a1506bd4c4975a9.svg";
export { ForwardRef as ReactComponent };